import SpacePath from "components/SpacePath";
import TagsList from "components/TagsList";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerBody from "ds/components/Drawer/Body";
import FormField from "ds/components/Form/Field";
import { Template } from "types/generated";
import DescriptionDetails from "components/DescriptionDetails";
import FormFieldViewText from "components/FormFields/ViewText";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import { useShowFullDescriptionWithBackArrow } from "ds/components/FullDescriptionDrawer/useShowFullDescriptionWithBackArrow";
import DrawerSimple from "ds/components/DrawerNew/Simple";

type TemplateDetailsProps = {
  item: Template;
  onEdit?: () => void;
};

const TemplateDetailsDrawer = createDrawer(({ item }: TemplateDetailsProps) => {
  const onOpenFullDescription = useShowFullDescriptionWithBackArrow(item.description);

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Template details" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <FormFieldViewText label="Name" value={item.name} />

        <FormField label="Space">
          <SpacePath variant="expandable" spaceId={item.space.id} fallbackName={item.space.name} />
        </FormField>

        <DescriptionDetails
          description={item.description}
          onOpenFullDescription={onOpenFullDescription}
        />

        {item.labels.length > 0 && (
          <FormField label="Labels">
            <TagsList tags={item.labels} alwaysExpanded />
          </FormField>
        )}
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showTemplateDetailsDrawer = createDrawerTrigger(TemplateDetailsDrawer);
